import { calculatePayment } from '@/utils/loanCalculator';
import { useEffect, useState } from 'react';

type CalculateParams = {
  loanValue: number;
  interestValue: number;
  timeLineValue: number;
  fixedValue?: number;
};

export const useCalculatePayment = ({
  loanValue,
  interestValue,
  timeLineValue,
  fixedValue = 0,
}: CalculateParams) => {
  const [payment, setPayment] = useState<number | string>(0);

  useEffect(() => {
    const newPayment = calculatePayment(
      loanValue,
      interestValue,
      timeLineValue,
      fixedValue
    );

    setPayment(newPayment);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loanValue, interestValue, timeLineValue]);

  return payment;
};
